/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useAuth } from '../context/auth-context';
import { translateErrors } from '../utils';
import Link from '../common/Link';
import TextFields from '../common/components/TextField/TextField';

const resetError = {
    email: {
        hasError: false,
        message: '',
    },
    password: {
        hasError: false,
        message: '',
    },
};

interface NavType {
    origin?: string;
}

const FormLogin = ({ origin }: NavType): JSX.Element => {
    const [error, setError] = useState(resetError);
    const [values, setValues] = useState({
        email: '',
        password: '',
    });
    const auth = useAuth();

    const handleLogin = async (e: React.SyntheticEvent) => {
        e.preventDefault();

        if (values && values.password === '') {
            setError({
                ...error,
                password: {
                    hasError: true,
                    message: 'Password requerido!',
                },
            });
        }
        if (values && values.email === '') {
            setError({
                ...error,
                email: {
                    hasError: true,
                    message: 'Email requerido!',
                },
            });
        }
        if (values && values.email !== '' && values.password !== '') {
            await auth.loginEmail(values.email.trim(), values.password);
            setError(resetError);
        }
    };

    const handleChangeEmail = (e: any) => {
        e.preventDefault();
        setError(resetError);
        if (e.target.value.trim() === '') {
            auth.clearErrorAuth();
        }
        setError({
            ...error,
            email: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, email: e.target.value.trim() });
    };

    const handleChangePassword = (e: any) => {
        e.preventDefault();
        setError(resetError);
        if (e.target.value.trim() === '') {
            auth.clearErrorAuth();
        }
        setError({
            ...error,
            password: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, password: e.target.value });
    };

    useEffect(() => {
        if (auth) {
            // console.log({ auth });
            auth.clearStateChangePassword();
        }
    }, [auth]);

    return (
        <form className="flex flex-col my-6" onSubmit={handleLogin}>
            <TextFields
                autoFocus={true}
                name={'email'}
                id={'email'}
                path={
                    'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                }
                label={'Email'}
                type={'text'}
                value={values.email}
                placeholder={'Email'}
                hasError={error.email.hasError}
                messageError={error.email.message}
                onChange={handleChangeEmail}
                background={'dark'}
            />
            <TextFields
                name={'password'}
                id={'password'}
                path={
                    'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                }
                label={'Contraseña'}
                type={'password'}
                value={values.password}
                placeholder={'Contraseña'}
                hasError={error.password.hasError}
                messageError={error.password.message}
                onChange={handleChangePassword}
                background={'dark'}
            />
            {auth.error && auth.error.origin && auth.error.origin === 'login' && (
                <>
                    <p className=" text-sm text-red-200">{translateErrors(auth.error.statusCode)}</p>
                    {auth.error.statusCode && auth.error.statusCode === 'UserNotConfirmedException' && (
                        <div className="w-full text-center ">
                            <Link to="/registro/codigo">
                                <p className={`mb-6 text-sm text-red-200  underline`}>Ingresa aqui el Codigo</p>
                            </Link>
                        </div>
                    )}
                </>
            )}
            <div className="w-full text-right my-1 mt-2">
                <Link to="/recuperar">
                    <p className={`text-sm ${origin === 'pago' ? 'text-sm-blue-primary' : 'text-white'}`}>
                        Olvidé la contraseña
                    </p>
                </Link>
            </div>
            {origin === 'login' && (
                <div className="w-full text-right my-1">
                    <Link to="/registro">
                        <p className={`text-sm text-white`}>¿No tienes cuenta?</p>
                    </Link>
                </div>
            )}
            <div className="w-full text-right my-1">
                <Link to="/">
                    <p className={`text-sm text-white`}>Ir al inicio</p>
                </Link>
            </div>
            <div className={`w-full text-right pt-4 cursor-pointer`}>
                <Link to="/registro/codigo">
                    <p className={`text-sm text-white`}>¿Tienes un Codigo para Validar el Registro?</p>
                </Link>
            </div>
            <button type="submit" className="w-full text-white px-4 py-4 rounded-lg text-lg mb-6 bg-sm-rent my-6">
                Ingresar
            </button>
        </form>
    );
};

export default FormLogin;
